import { createReducer, createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
	getOrders: ['status'],
	getOrdersDone: ['orders', 'message'],
	getOrdersError: ['errorMessage'],
	addOrder: ['order', 'history'],
	addOrderDone: ['message'],
	addOrderError: ['errorMessage'],
	deleteOrder: ['order'],
	deleteOrderDone: ['message'],
	deleteOrderError: ['errorMessage'],
	changeOrderStatus: ['order', 'incomingStatus'],
	setOrder: ['order'],
});

export const INITIAL_STATE = {
	orders: [],
	order: {},
	message: '',
	errorMessage: '',
	loading: false,
};

export const OrdersTypes = Types;
export default Creators;

const fetchRequest = (state) => ({
	...state,
	loading: true,
});

const getOrdersDone = (state, { orders, message }) => ({
	...state,
	loading: false,
	message,
	orders,
})

const showErrorMessage = (state, { errorMessage }) => ({
	...state,
	loading: false,
	errorMessage,
});

const showMessage = (state, { message }) => ({
	...state,
	message,
	loading: false,
})

const setOrder = (state, { order }) => ({
	...state,
	order,
	loading: false,
});

export const reducer = createReducer(INITIAL_STATE, {
	[Types.GET_ORDERS]: fetchRequest,
	[Types.GET_ORDERS_DONE]: getOrdersDone,
	[Types.GET_ORDERS_ERROR]: showErrorMessage,
	[Types.CHANGE_ORDER_STATUS]: showMessage,
	[Types.ADD_ORDER]: fetchRequest,
	[Types.ADD_ORDER_DONE]: showMessage,
	[Types.ADD_ORDER_ERROR]: showErrorMessage,
	[Types.DELETE_ORDER]: fetchRequest,
	[Types.DELETE_ORDER_DONE]: showMessage,
	[Types.DELETE_ORDER_ERROR]: showErrorMessage,
	[Types.SET_ORDER]: setOrder,
});